import React, { Component } from 'react';
import { Container, Row, Col, Stack, Image } from 'react-bootstrap';
import { Avatar } from './Avatar';
import FullLogo5 from '../images/officialLogo550.png';
import '../styles/MastHead.css';
export class MastHead extends Component{
    render() {
        const avaDisplay = (this.props.isAuthenticated === true) ? <Avatar onCompanyChange={this.props.onCompanyChange} currentUser={this.props.currentUser} currentCompanyId={this.props.currentCompanyId} /> : <div></div>;
        return (
            <Container id="siteMastHead" fluid>
                <Row id="mastHeadRow" className="align-items-center">
                    <Col md={7} sm={12}>
                        <Stack direction="horizontal">
                            <Image
                                alt="UnitedHealth Group Logo"
                                src={FullLogo5}                              
                            />
                        </Stack>
                  </Col>
                    <Col md={5} sm={12}>
                        {avaDisplay}
           </Col>
            </Row>
            </Container>
        )
    }
}